import { Energietraeger } from '../../domain/model/energietraeger';

export class ErzeugungsanlageFilter {
    constructor(
        public netzbetreiberName?: string,
        public netzbetreiberTeilgebiet?: string,
        public dokumentenId?: string,
        public steuerbareResourceId?: string,
        public technischeResourceId?: string,
        public bezVnbIntern?: string,
        public stadtwerkeId?: string,
        public ortsname?: string,
        public stationsname?: string,
        public trafoFeldName?: string,
        public energietraeger?: Energietraeger,
        public status?: boolean,
        public installierteLeistungMin?: number,
        public installierteLeistungMax?: number,

        // Not used in eg. filter form. It's used for eg. validation
        public anlagenschluessel?: string,
    ) {
    }
}

